import React, { useEffect, useState } from "react";
import * as Survey from "survey-react-ui";
import "survey-core/defaultV2.min.css";
import { useParams } from "react-router-dom";
import { getSurveyStructureByHash } from "../../services/http/surveyHttpService";
import {
 
  Box,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { v4 as uuidv4 } from "uuid";

import { initSurveyService } from "../../services/http/surveyHttpService";
import { useToast } from "@chakra-ui/react";
import { useSession } from "../../SessionContext";
import createAxiosInstance from "../../interceptors/useAxiosInterceptors";
import { useNavigate } from "react-router-dom";
import logout from "../../services/authService";
import Header from "../Header";
import { receiveAnswerADP } from "../../services/http/surveyHttpService";
import { reverseEasing } from "framer-motion";
import { useTranslation } from "react-i18next";
const SurveyAnswerView = () => {
  const [survey, setSurvey] = useState(null);
  const [responseGetSurveyStructure, setResponseGetSurveyStructure] = useState(null);
  const {t} = useTranslation();
  const toast = useToast();
  const { clearSessionData} = useSession();
  const navigate = useNavigate();
  let axiosInstance = createAxiosInstance(async (axiosInstance)=> {

    logout(t, clearSessionData,navigate,toast,axiosInstance)
    
  });

  initSurveyService(t, toast, axiosInstance)


const {  sha_key } = useParams();


  useEffect(() => {
    

  getSurveyStructureByHash(sha_key).then(res => {

      if(res && res.message && res.message.survey_structure) {
        const surveyModel = new Survey.Model(res.message.survey_structure);
        setResponseGetSurveyStructure(res.message)
        setSurvey(surveyModel);
    
      }
      
    })
    
   
    
  },[]);

  // Resetta la pagina iniziale ogni volta che il modale si apre
  

  return (
   <>
          {survey ? (
            <Box
              h="100vh"
              p={4}
              bg="gray.50"
              rounded="md"
              shadow="md"
              overflowY="auto"
            >


{!sessionStorage.getItem("username") && (
  <Header isVisibleMenuLang={false} />
)}

              
              <Survey.Survey model={survey} onComplete={(surveyRes)=>{
              


             

                let body = {
                  expert_id: parseInt(responseGetSurveyStructure.expert_id),
                  id_survey_info : responseGetSurveyStructure.id_survey_info,
                  sha_key: sha_key,  json_answer:surveyRes.data};


                  console.log(body)

                  


                receiveAnswerADP(body ).then(res => {
                  console.log(res)
                })

                
              }} />
            </Box>
          ) : (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="80vh"
              p={5}
            >
              <Spinner size="lg" color="blue.500" />
              <Text ml={3} fontSize="lg" color="gray.600">
                Loading survey...
              </Text>
            </Box>
          )}
     </>
  );
};

export default SurveyAnswerView;
